const AlreadyInGame = () => {
  return (
    <div className="flex flex-col w-full h-full justify-center items-center">
      <h3>
        You are already in one of the active games. You can only play one game
        at a time
      </h3>
    </div>
  )
}

export default AlreadyInGame
